// extracted by mini-css-extract-plugin
export default {"right":"right__VhvEi"};